/* global connect React Component */
import mixinsFunc from "../mixins";
export class BusinessInfo extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("BusinessInfo");
    let mixins = mixinsFunc(this);
    this.state = {
      links: mixins.links || [],
      shareHolders: [mixins.businessInfo],
      newrecord:true,
      fields: {
        businessInfo: mixins.businessInfo,
      },
    };
  }

  addShareHolder() {
    let mixins = mixinsFunc(this);
    let shareHolders = this.state.shareHolders;
    let payload = mixins.businessInfo;
    let lastRow = shareHolders[shareHolders.length-1];
    payload.find(o=>o.name=='snum').defaultValue = lastRow.find(o=>o.name=='snum').defaultValue + 1;
    shareHolders.push(payload);
    this.setState({ shareHolders: [...shareHolders] });
  }

  deleteShareHolder(index) {
    let shareHolder = this.state.shareHolders.find((o, i) => i == index);
    console.log({shareHolder});
    if(shareHolder.find(o=>o.name=='snum')["data-id"]) {
      this.api.execApi("deleteBusiness", {},{
        director_id:row.director_id
      }).then(() => {
        this.getBusinessData();
      }).catch(reject);
    } else {
      let shareHolders = this.state.shareHolders.filter((o, i) => i != index);
      this.setState({ shareHolders });
    }
  }

  saveShareHolder(index) {
    let arr = this.state.shareHolders.find((o, i) => i == inedx);
    if (arr) {
      console.log({ arr });
    }
  }

  AddShareHolder(props) {
    const isPvtLtd = props.statedata.infoData?.company_type === "ppc";
    return (
      <button
        type="button"
        className="btn btn-outline-warning border-0 d-flex align-items-center"
        onClick={() => props.addShareHolder()}
      >
        <i className="fa fa-plus mx-2"></i>
        Add {isPvtLtd?'Director':'Partner'}
      </button>
    );
  }

  breadCumRight() {
    return <AppStepper index={3} count={5}></AppStepper>;
  }

  getCompanyData() {
    return new Promise((resolve,reject)=>{
      this.api.execApi('getCompany').then((response) => {
        let data = response.data;
        this.setState((state)=>({
          infoData: data
        }),()=>resolve(data));
      }).catch(reject);
    })
  }

  getBusinessData() {
    let mixins = mixinsFunc(this);
    return new Promise((resolve, reject) => {
      this.api.execApi('getBusiness').then(async (response) => {
        let data = response.data;
        let rows = data.items || [];
        let infoData = await this.getCompanyData();
        let newShareList = [];
        newShareList.length = infoData.num_of_directors;
        let emptyData = mixins.businessInfo.reduce(((o,n)=>({...o,[n.name]:n.defaultValue??""})),{});
        newShareList.fill(emptyData);
        newShareList = newShareList.map((o,i)=>rows[i]??o);
        console.log({newShareList,rows});
        this.setState((state) => ({
          list:rows,
          newrecord:!newShareList.length,
          shareHolders: ((newShareList && newShareList.length!=0)?newShareList:state.shareHolders).map((data, i) => {
            data['snum'] = (i + 1);
            return mixins.businessInfo.map(o => ({
              ...o,
              "data-id":data.director_id,
              defaultValue: data[o.name] ?? ""
            }));
          }),
        }), resolve);
      }).catch(reject);
    })
  }

  get formList() {
    if(this.refs.list) {
      return [...this.refs.list.querySelectorAll('form')];
    }
    return [];
  }

  get totalShareHolding() {
    return this.formList
    .map(form=>form.getData())
    .map(o=>o.share_holding_pc).sum();
  }

  get isAllFormValid() {
    return this.formList.reduce((flag,form)=>flag && form.checkValidity(),true)
  }

  get isShareHolding() {
    return this.totalShareHolding==100;
  }
  get isValidNext() {
    let flag = this.isShareHolding;
    flag = flag && this.isAllFormValid;
    return flag;
  }

  componentDidMount() {
    this.getBusinessData();
  }

  saveBusinessInfo(e,data) {
    return new Promise((resolve,reject)=>{
      let id = e.target.querySelector('input').dataset.id;
      let row = this.state.list.find((o,i)=>o.director_id==id)
      if(row) {
        let payload = {...data};
        this.api.execApi("putBusiness", payload,{
          director_id:row.director_id
        }).then(() => {
          resolve({message:"Update Successfull"});
        }).catch(reject);
      } else {
        this.api.execApi("postBusiness", data).then(() => {
          resolve({message:"Add Successfull"});
        }).catch(reject);
      }
    });
  }

  submitRecord() {
    if(this.isValidNext) {
      let promises = this.formList.map(form=>this.saveBusinessInfo({
        target:form
      },form.getData()));
      Promise.all(promises).then((fullfilled)=>{
        console.log({fullfilled});
        this.getBusinessData().then(()=>{
          navigate("/app/profile/doc_upload");
        });
      }).catch(()=>{

      })
    } else if(!this.isShareHolding){
      alert("Total Shareholding must be 100%");
    } else {
      alert("Please fill proper and required fields");
    }
  }

  render() {
    let { AddShareHolder, breadCumRight } = this;
    let { links, fields, shareHolders, newrecord } = this.state;
    const isNotIndv = this.state.infoData?.company_type !== "indv";
    const isPvtLtd = this.state.infoData?.company_type === "ppc";

    if(!isNotIndv&&fields[0]) {
      fields[0].defaultValue = 100;
    }
    if(isPvtLtd) {
      shareHolders = shareHolders.map(fild=>fild.map((o)=>({
        ...o,
        ...(o.name=="director_name"?{
          label:"Director Name"
        }:{})
      })));
    }
    /* eslint-disable-next-line react/jsx-no-undef */

    return (
      <AppWrapper
        customTitle="Update Profile"
        title="Profile"
        slots={{ breadCumRight }}
      >
        <AppLinkTabs data={links}></AppLinkTabs>
        <div className="card">
          <div className="card-body">
            <div ref="list" >
              <AppWarningBage className="ms-auto">
                Total Shareholding must be 100%
              </AppWarningBage>
              {shareHolders.map((fields, i) => (
                <AppForm key={i} onSubmit={(...args) => this.saveBusinessInfo(i,...args)}>
                  <Row className="mx-0">
                    {fields.map((field, j) => (
                      <Col key={field.name} className={field.fieldclass}>
                        <AppInput {...field}></AppInput>
                      </Col>
                    ))}
                    <Col>
                    {
                      <button
                          type="button"
                          className="square_delete_btn my-auto bg-white relative bottom-[-33px]"
                          onClick={() => this.deleteShareHolder(i)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                    }
                    </Col>
                  </Row>
                </AppForm>
              ))}
              {
                (isNotIndv) && <AddShareHolder statedata={this.state} addShareHolder={() => this.addShareHolder()} />
              }
              <div>
                <Row>
                  <Col className="text-right">
                    <button className="btn add-btn" onClick={()=>this.submitRecord()}>Save & Next</button>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </AppWrapper>
    );
  }
}

export default connect(BusinessInfo);
